var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatchingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 11.9997C11.7066 11.9997 12 12.293 12 12.6663C12 13.0397 11.7066 13.333 11.3333 13.333C10.96 13.333 10.6666 13.0397 10.6666 12.6663C10.6666 12.293 10.96 11.9997 11.3333 11.9997ZM11.3333 9.99967C9.51329 9.99967 7.95996 11.1063 7.33329 12.6663C7.95996 14.2263 9.51329 15.333 11.3333 15.333C13.1533 15.333 14.7066 14.2263 15.3333 12.6663C14.7066 11.1063 13.1533 9.99967 11.3333 9.99967ZM11.3333 14.333C10.8913 14.333 10.4673 14.1574 10.1548 13.8449C9.84222 13.5323 9.66663 13.1084 9.66663 12.6663C9.66663 12.2243 9.84222 11.8004 10.1548 11.4878C10.4673 11.1753 10.8913 10.9997 11.3333 10.9997C11.7753 10.9997 12.1992 11.1753 12.5118 11.4878C12.8244 11.8004 13 12.2243 13 12.6663C13 13.1084 12.8244 13.5323 12.5118 13.8449C12.1992 14.1574 11.7753 14.333 11.3333 14.333ZM6.17996 13.333H3.99996V2.66634H8.66663V5.99967H12V8.71301C12.4666 8.76634 12.9066 8.87967 13.3333 9.03967V5.33301L9.33329 1.33301H3.99996C3.64634 1.33301 3.3072 1.47348 3.05715 1.72353C2.8071 1.97358 2.66663 2.31272 2.66663 2.66634V13.333C2.66663 13.6866 2.8071 14.0258 3.05715 14.2758C3.3072 14.5259 3.64634 14.6663 3.99996 14.6663H6.99996C6.66408 14.2635 6.38792 13.8145 6.17996 13.333Z",
    fill: "#1B3E61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchingIcon);
export default __webpack_public_path__ + "static/media/watching-icon.1eddd0ea669d1c3a39159712b01c8ee9.svg";
export { ForwardRef as ReactComponent };